<template>
  <div v-if="products.length > 0" class="c-container">

    <div class="flex items-center q-px-md q-px-md-none q-px-lg-md">
      <div class="s-font-2xs text-weight-bold text-grey-7">
        {{ title }}
      </div>
    </div>

    <Carousel v-bind="carouselOptions" class="q-pl-md">
      <CarouselSlide
        v-for="product in products"
        :key="product.ID"
      >
        <div class="c-slide">
          <ProductCardLine
            :product="product"
            class="full-height"
          />
        </div>
      </CarouselSlide>
      <template #addons>
        <CarouselNavigation v-if="showNavigation" />
      </template>
    </Carousel>

  </div>
</template>

<script setup lang="ts">
import ProductCardLine from "@/components/Shop/ProductCard/ProductCardLine.vue";
import { ProductModel } from "@/modules/shop/composable/useProduct";
import { computed } from "vue";

interface Props {
  products: ProductModel[];
  title?: string;
  showNavigation?: boolean;
  itemsToShow?: number;
}

const props = withDefaults(defineProps<Props>(), {
  title: "Товары по акциям",
  showNavigation: true,
  itemsToShow: 1.23,
});

const carouselOptions = computed(() => ({
  gap: 16,
  itemsToShow: props.itemsToShow,
  snapAlign: "start",
  wrapAround: false,
  transition: 300,
}));
</script>

<style scoped lang="scss">
.c-container {
  position: relative;
}

.c-slide {
  height: 100%;
  padding-right: 0px;
  padding-bottom: 4px;
}
</style>
